
import request from '@/common/request.js'; // 全局请求方法
import api from '@/common/api.js'; // 全局API
//创建一个函数
function str2obj(str) {
	//创建一个空对象
	var obj = {};
	//截取?后的字符串
	str = str.slice(1);
	//按照&切割字符串为数组
	var arr = str.split("&");
	//遍历arr数组
	for (var s of arr) { //数组元素被遍历后成为字符串
		//每遍历一次，将已遍历的字符串按照=分割成数组，并且将当前元素的下标放入key中，值放入value中
		var [key, value] = s.split("=");
		//如果obj对象中没有下标是key的元素，就将obj[key]通过强行赋值的方式添加进去
		if (obj[key] === undefined) {
			obj[key] = value;
		} else {
			//反之如果存在的话，就将当前元素的值拼接到已存在的数组中
			obj[key] = [].concat(obj[key], value);
		}
	}
	//最后将obj对象抛出到函数外部
	return obj;
}

export function posterInit(options) {
	let result = options // 默认值对象值
	if (typeof options === 'string') {
		result = this.str2obj(scene)
	}
	if (result.scene) { // 有海报分享标识
		getCode(result.scene).then(res => {
			if(res.code != 0) return 
			let data = JSON.parse(res.data.content)
			uni.setStorageSync('pid', data.share_user_id)
			if(data && data.pid){
				uni.setStorageSync('pid', data.pid)
			}
		})
	}
}

function getCode(id) { // 海报小程序
	return request
		.request({
			url: api.poster.posterCodeDetail,
			showLoading: true,
			method: "post",
			header: {
				contentType: 'application/x-www-form-urlencoded'
			},
			data: {
				scene: id
			}
		})
}
